// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3FjWp","sendOtp":"AuthorizeToLogin_sendOtp___6k2o"};